{
  "sites": {
    "chancePerSurface": 0.05,
    "maxPerChunk": 4,
    "hover": 26
  },

  "items": {
    "poptart": { "give": "weapon", "weapon": "poptart", "ammo": 10, "frequency": 6, "respawn": 12 },
    "cereal":  { "give": "weapon", "weapon": "cereal",  "ammo": 18, "frequency": 5, "respawn": 16 },
    "shoop":   { "give": "weapon", "weapon": "shoop",   "ammo": 6,  "frequency": 3, "respawn": 25 },
    "stonks":  { "give": "weapon", "weapon": "stonks",  "ammo": 12, "frequency": 3, "respawn": 20 },
    "gusta":   { "give": "weapon", "weapon": "gusta",   "ammo": 5,  "frequency": 3, "respawn": 24 },
    "fine":    { "give": "weapon", "weapon": "fine",    "ammo": 3,  "frequency": 2, "respawn": 30 },
    "cat":     { "give": "weapon", "weapon": "cat",     "ammo": 2,  "frequency": 2, "respawn": 35 },
    "dodgeball": { "give": "weapon", "weapon": "dodgeball", "ammo": 4,  "frequency": 2, "respawn": 22 },
    "fish":      { "give": "weapon", "weapon": "fish",      "ammo": 10, "frequency": 3, "respawn": 18 },
    "blocks":    { "give": "blocks", "material": "dirt",     "amount": 8, "frequency": 3, "respawn": 14 },
    "mallet":    { "give": "weapon", "weapon": "mallet",     "ammo": 15, "frequency": 3, "respawn": 18 },

    "health":  { "give": "health", "amount": 25, "frequency": 1.2, "respawn": 30 },
    "armor":   { "give": "armor",  "amount": 50, "frequency": 0.8, "respawn": 45 },

    "jetpack": { "give": "jetpack", "fuel": 1000, "frequency": 1, "respawn": 40 }
  }
}
